import {getLoginMethod, getLogoutMethod} from "@/services/AuthMethods";
import store from "@/store";

function prepareQueryStrings() {
    if (store.state.context.continueUrl) {
        return {continue: store.state.context.continueUrl}
    }
    return {}
}

export function navigateToLoginPage ({next}) {
    next({name: getLoginMethod(), query: prepareQueryStrings()});
}

export function navigateToLogoutPage({next}) {
    next({name: getLogoutMethod(), query: prepareQueryStrings()});
}

